var _defs, _path, _path2, _polyline, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _path3, _polygon2, _polygon3, _rect45, _polygon4, _polygon5, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect46, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect47, _path22, _path23, _path24, _rect48, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _rect49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _rect50, _rect51, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _rect52, _path125, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSazandegan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 303.9 390.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc8b2;}.cls-1,.cls-2,.cls-6,.cls-7{fill-rule:evenodd;}.cls-2,.cls-5{fill:#fff;}.cls-3,.cls-7{fill:#343434;}.cls-4,.cls-6{fill:#fe4800;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.31,393.07c1.32,88.28,98.47,123.14,186.31,123.14s116.09-42.57,116.09-130.85-71.4-200-158.84-208.47C188.63,167,146,304.78,147.31,393.07Z",
    transform: "translate(-145.93 -125.34)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.42,393.07c1.33,88.28,98.48,123.14,186.32,123.14s116.09-42.57,116.09-130.85S378.42,185.36,291,176.89C188.75,167,146.1,304.78,147.42,393.07Z",
    transform: "translate(-145.93 -125.34)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "34.5 183.59 96.52 193.72 97.49 350.64 32.56 350.64 34.5 184.98"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.61 47.67 121.54 167.66 132.33 168.24 146.12 168.24 148.31 148.02 157.15 144.81 158.52 112.89 178.57 103.92 179.02 46.08 127.61 44.81 119.61 47.67"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.52,
    y: 199.12,
    width: 9.94,
    height: 9.94
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.52,
    y: 216.95,
    width: 9.94,
    height: 9.94
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.52,
    y: 234.78,
    width: 9.94,
    height: 9.94
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.52,
    y: 252.61,
    width: 9.94,
    height: 9.94
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.52,
    y: 270.44,
    width: 9.94,
    height: 9.94
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.52,
    y: 288.27,
    width: 9.94,
    height: 9.94
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.52,
    y: 306.11,
    width: 9.94,
    height: 9.94
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.78,
    y: 199.12,
    width: 9.94,
    height: 9.94
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.78,
    y: 216.95,
    width: 9.94,
    height: 9.94
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.78,
    y: 234.78,
    width: 9.94,
    height: 9.94
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.78,
    y: 252.61,
    width: 9.94,
    height: 9.94
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.78,
    y: 270.44,
    width: 9.94,
    height: 9.94
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.78,
    y: 288.27,
    width: 9.94,
    height: 9.94
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.78,
    y: 306.11,
    width: 9.94,
    height: 9.94
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 113.65,
    y: 199.12,
    width: 9.94,
    height: 9.94
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 113.65,
    y: 216.95,
    width: 9.94,
    height: 9.94
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 113.65,
    y: 234.78,
    width: 9.94,
    height: 9.94
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 113.65,
    y: 252.61,
    width: 9.94,
    height: 9.94
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 113.65,
    y: 270.44,
    width: 9.94,
    height: 9.94
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 113.65,
    y: 288.27,
    width: 9.94,
    height: 9.94
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 113.65,
    y: 306.11,
    width: 9.94,
    height: 9.94
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 149.72,
    y: 199.12,
    width: 9.94,
    height: 9.94
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 149.72,
    y: 216.95,
    width: 9.94,
    height: 9.94
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 149.72,
    y: 234.78,
    width: 9.94,
    height: 9.94
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 149.72,
    y: 252.61,
    width: 9.94,
    height: 9.94
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 149.72,
    y: 270.44,
    width: 9.94,
    height: 9.94
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 149.72,
    y: 288.27,
    width: 9.94,
    height: 9.94
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 149.72,
    y: 306.11,
    width: 9.94,
    height: 9.94
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 199.12,
    width: 9.94,
    height: 9.94
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 181.14,
    width: 9.94,
    height: 9.94
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 163.17,
    width: 9.94,
    height: 9.94
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 145.2,
    width: 9.94,
    height: 9.94
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 128.22,
    width: 9.94,
    height: 9.94
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 110.25,
    width: 9.94,
    height: 9.94
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 216.95,
    width: 9.94,
    height: 9.94
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 234.78,
    width: 9.94,
    height: 9.94
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 252.61,
    width: 9.94,
    height: 9.94
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 270.44,
    width: 9.94,
    height: 9.94
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 288.27,
    width: 9.94,
    height: 9.94
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 174.05,
    y: 306.11,
    width: 9.94,
    height: 9.94
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.27,
    y: 181.42,
    width: 9.74,
    height: 9.39
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.27,
    y: 163.34,
    width: 9.74,
    height: 9.39
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.27,
    y: 288.29,
    width: 9.74,
    height: 9.39
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.38,
    y: 288.29,
    width: 9.74,
    height: 9.39
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.15,476V463.45l3.71-3.93,4.81-.77v-5.17l3.39-2.61,6.83-.81v-142l-14.33.28.67,1.36-.09,17.5-2.25,4.63-5.33,2.22H236.85l-4.56-4.18-1.7-5V307.56h-4.54l-3-3.47-.53-4.85,2.13-2.58,3-2.46,4.82-.36h43.21V271.27l17.56.29v13.13l6.29.24c.18,0,5,2.08,5,2.08l4,3.13,2.13,4.47,85.38-.77,22.28,0,4.5,2.63s1.6,2.45,1.65,2.58.4,1.81.4,2.06a10.61,10.61,0,0,1-.54,2.22c-.13.13-2.09,2.58-2.09,2.58s-2.68,1.25-3.12,1.52-3.88,1.07-3.88,1.07L311.06,308l.57,9.27-2.75,6.69-6.49,4.77-9.45.71.42,120.78,7.9.77,3.09,2.14s.47,2,.47,2.2-.06,3.92-.06,3.92h4.16l2.44,2.61.65,4.69-.12,9.57Z",
    transform: "translate(-145.93 -125.34)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "241.23 208.6 267.87 208.6 268.23 237.56 241.23 237.91 241.23 208.6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "192.8 350.64 192.8 294.23 210.04 294.23 210.04 276.76 226.79 276.76 226.35 247.36 239.89 247.72 239.89 273.38 269.51 273.23 269.51 247.81 280.73 247.86 280.73 350.75 192.8 350.64"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 103.63,
    y: 181.6,
    width: 1.94,
    height: 3.37
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "130.85 171.54 130.85 173.51 128.66 173.9 128.66 171.93 130.85 171.54"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "138.67 170.14 138.67 172.11 136.48 172.5 136.48 170.53 137.55 170.34 138.67 170.14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.46,291.1v4.09h-1.94v-2.93l-2.41.43-1.72.31-.51.09a.36.36,0,0,0,0-.09c-.09-.18-.19-.35-.29-.52a1,1,0,0,1-.56-.87v0a1.85,1.85,0,0,0-.19-.27l.19,0,1.94-.34.23-.05,4.16-.74a1,1,0,0,1,.79.21A1,1,0,0,1,315.46,291.1Z",
    transform: "translate(-145.93 -125.34)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.52,306.94h1.94V477a1,1,0,0,1-1.94,0Z",
    transform: "translate(-145.93 -125.34)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M251.5,476V453.13a1,1,0,0,0-1.94,0V477a1,1,0,0,0,1,1h64a1,1,0,0,0,0-1.94Z",
    transform: "translate(-145.93 -125.34)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.37,315l2.19.36v2l-2.19-.35-48.94-8V477a1,1,0,0,1-1.94,0V307.79a1,1,0,0,1,.34-.74,1,1,0,0,1,.79-.22l11,1.79,1.93.32Z",
    transform: "translate(-145.93 -125.34)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M244.39,333v90.72a1,1,0,0,1-1.82.45.87.87,0,0,1-.12-.45V333Z",
    transform: "translate(-145.93 -125.34)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.45,476h-63a1,1,0,1,0,0,1.94h64a1,1,0,0,0,1-1V455.81a1,1,0,1,0-1.93,0V476Z",
    transform: "translate(-145.93 -125.34)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M354.31,218.77v76.42h-1.94v-75l-3.89,1.56a.28.28,0,0,1-.12,0l-22.48,9h0l-.06,0L305,239.15v31a1,1,0,0,1-1.93,0V238.49a1,1,0,0,1,.61-.9l20.81-8.33,1.94-.77,5.32-2.13,1.93-.77,13.4-5.36,1.94-.78,4-1.58a1,1,0,0,1,1.33.9Z",
    transform: "translate(-145.93 -125.34)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 206.44,
    y: 181.6,
    width: 1.94,
    height: 113.76
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M354.31,476v1a1,1,0,0,1-1,1H314.49a1,1,0,1,1,0-1.93Z",
    transform: "translate(-145.93 -125.34)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M347.09,212.88v8a1,1,0,1,0,1.93,0v-9.43a1,1,0,0,0-.42-.8,1,1,0,0,0-.9-.09l-15.34,6.12a1,1,0,0,0-.61.9v9.21a1,1,0,1,0,1.94,0v-8.55l13.4-5.36Z",
    transform: "translate(-145.93 -125.34)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.48,287.58v9a1,1,0,0,1-1,1h-.1v-2.32h-.87V293h.87v-1.45A7.89,7.89,0,0,1,283.48,287.58Z",
    transform: "translate(-145.93 -125.34)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.44,147.61v82.31a1,1,0,0,1-.57.88l-.06,0a.8.8,0,0,1-.34.07,1,1,0,0,1-1-1V148.58h-41V272.64h-1.94v-125a1,1,0,0,1,1-1h43A1,1,0,0,1,326.44,147.61Z",
    transform: "translate(-145.93 -125.34)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.48,163.62a1,1,0,0,1-1,1h-15v130.6h-1.93V163.62a1,1,0,0,1,1-1h16A1,1,0,0,1,283.48,163.62Z",
    transform: "translate(-145.93 -125.34)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.92,139.93v7.68a1,1,0,1,0,1.93,0V139a1,1,0,0,0-1-1h-9.79a1,1,0,0,0-1,1v8.65a1,1,0,1,0,1.94,0v-7.68Z",
    transform: "translate(-145.93 -125.34)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303,139V126.31a1,1,0,1,1,1.93,0V139a1,1,0,1,1-1.93,0Z",
    transform: "translate(-145.93 -125.34)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.32,159v4.65a1,1,0,0,0,1.94,0V158a1,1,0,0,0-1-1h-5.57a1,1,0,0,0-1,1v5.62a1,1,0,0,0,1.94,0V159Z",
    transform: "translate(-145.93 -125.34)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M273.54,158V142.07a1,1,0,1,1,1.93,0V158a1,1,0,1,1-1.93,0Z",
    transform: "translate(-145.93 -125.34)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M430.52,483.06H165.64a1,1,0,0,1,0-1.93H430.52a1,1,0,0,1,0,1.93Z",
    transform: "translate(-145.93 -125.34)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M325.44,488.21H228.11a1,1,0,1,1,0-1.93h97.33a1,1,0,1,1,0,1.93Z",
    transform: "translate(-145.93 -125.34)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.83,
    y: 332.79,
    width: 1.93,
    height: 2.19
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M272.76,475.33h1.93V477a1,1,0,0,1-.19.57.93.93,0,0,1-.77.39,1,1,0,0,1-1-1Z",
    transform: "translate(-145.93 -125.34)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.78,446.94v1.94h-2.09v2.84h-1.93v-3.81a1,1,0,0,1,1-1Z",
    transform: "translate(-145.93 -125.34)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M292.26,447.91v3.81h-1.93v-2.19h1.72v-2.22A1,1,0,0,1,292.26,447.91Z",
    transform: "translate(-145.93 -125.34)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 144.4,
    y: 332.79,
    width: 1.93,
    height: 2.19
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290.33,475.33h1.93V477a1,1,0,0,1-.19.57.93.93,0,0,1-.77.39,1,1,0,0,1-1-1Z",
    transform: "translate(-145.93 -125.34)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.51,448.88V477a1,1,0,1,0,1.93,0v-29a1,1,0,0,0-1-1H319.91a1,1,0,0,0-1,1v29a1,1,0,1,0,1.93,0V448.88Z",
    transform: "translate(-145.93 -125.34)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.61,430.81h-10a.49.49,0,0,0-.48.48v10a.49.49,0,0,0,.48.49h10a.49.49,0,0,0,.49-.49v-10A.49.49,0,0,0,305.61,430.81Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.06,431.78v.65a.48.48,0,1,0,1,0V431.3a.48.48,0,0,0-.48-.49h-10a.48.48,0,0,0-.48.49v10a.48.48,0,0,0,.48.48h7.89a.49.49,0,0,0,0-1H225v-9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.32,430.81h-10a.49.49,0,0,0-.49.48v10a.49.49,0,0,0,.49.49h10a.49.49,0,0,0,.48-.49v-10A.49.49,0,0,0,198.32,430.81Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.43,430.81h-10a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.49h10a.48.48,0,0,0,.48-.49v-10A.48.48,0,0,0,216.43,430.81Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.54,359.63h-10a.49.49,0,0,0-.48.49v10a.49.49,0,0,0,.48.48h10a.49.49,0,0,0,.49-.48v-10A.49.49,0,0,0,234.54,359.63Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.32,359.63h-10a.49.49,0,0,0-.49.49v10a.49.49,0,0,0,.49.48h10a.49.49,0,0,0,.48-.48v-10A.49.49,0,0,0,198.32,359.63Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.43,359.63h-10a.48.48,0,0,0-.48.49v10a.48.48,0,0,0,.48.48h10a.48.48,0,0,0,.48-.48v-10A.48.48,0,0,0,216.43,359.63Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.54,395.12h-10a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.48h10a.48.48,0,0,0,.49-.48v-10A.48.48,0,0,0,234.54,395.12Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.32,395.12h-10a.48.48,0,0,0-.49.48v10a.48.48,0,0,0,.49.48h10a.48.48,0,0,0,.48-.48v-10A.48.48,0,0,0,198.32,395.12Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.43,395.12h-10a.47.47,0,0,0-.48.48v10a.47.47,0,0,0,.48.48h10a.47.47,0,0,0,.48-.48v-10A.47.47,0,0,0,216.43,395.12Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.06,330.53v3.39h-9v-9h6.52c0-.13,0-.25,0-.38v-.59h-7a.49.49,0,0,0-.48.48v10a.49.49,0,0,0,.48.49h10a.49.49,0,0,0,.49-.49v-3A8.5,8.5,0,0,1,234.06,330.53Z",
    transform: "translate(-145.93 -125.34)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.32,323.94h-10a.49.49,0,0,0-.49.48v10a.49.49,0,0,0,.49.49h10a.49.49,0,0,0,.48-.49v-10A.49.49,0,0,0,198.32,323.94Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.43,323.94h-10a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.49h10a.48.48,0,0,0,.48-.49v-10A.48.48,0,0,0,216.43,323.94Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.54,412.85h-10a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.48h10a.48.48,0,0,0,.49-.48v-10A.48.48,0,0,0,234.54,412.85Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.32,412.85h-10a.48.48,0,0,0-.49.48v10a.48.48,0,0,0,.49.48h10a.48.48,0,0,0,.48-.48v-10A.48.48,0,0,0,198.32,412.85Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.43,412.85h-10a.47.47,0,0,0-.48.48v10a.47.47,0,0,0,.48.48h10a.47.47,0,0,0,.48-.48v-10A.47.47,0,0,0,216.43,412.85Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.54,341.67h-10a.49.49,0,0,0-.48.48v10a.49.49,0,0,0,.48.49h10a.49.49,0,0,0,.49-.49v-10A.49.49,0,0,0,234.54,341.67Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.32,341.67h-10a.49.49,0,0,0-.49.48v10a.49.49,0,0,0,.49.49h10a.49.49,0,0,0,.48-.49v-10A.49.49,0,0,0,198.32,341.67Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.43,341.67h-10a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.49h10a.48.48,0,0,0,.48-.49v-10A.48.48,0,0,0,216.43,341.67Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.54,377.15h-10a.49.49,0,0,0-.48.49v10a.49.49,0,0,0,.48.48h10a.49.49,0,0,0,.49-.48v-10A.49.49,0,0,0,234.54,377.15Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.32,377.15h-10a.49.49,0,0,0-.49.49v10a.49.49,0,0,0,.49.48h10a.49.49,0,0,0,.48-.48v-10A.49.49,0,0,0,198.32,377.15Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.43,377.15h-10a.48.48,0,0,0-.48.49v10a.48.48,0,0,0,.48.48h10a.48.48,0,0,0,.48-.48v-10A.48.48,0,0,0,216.43,377.15Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.43,302a5.56,5.56,0,0,0,.75,2.1l-2.63-.48-29-5.28v11.38a1,1,0,0,1-1.93,0V297.16a1,1,0,0,1,.34-.75,1,1,0,0,1,.8-.21l6.24,1.13,1.93.36L212.75,300l1.93.35,6.49,1.18,2.26.41Z",
    transform: "translate(-145.93 -125.34)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.98,
    y: 181.6,
    width: 1.94,
    height: 3.37
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.87,431.78v-1h-1.79a.46.46,0,0,0-.41.23.52.52,0,0,0-.07.25v10a.43.43,0,0,0,.07.25.45.45,0,0,0,.41.24h1.79v-1h-1.31v-9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.06,323.94h-10a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.49h10a.48.48,0,0,0,.48-.49v-10A.48.48,0,0,0,348.06,323.94Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.46,242.94H304a.48.48,0,0,0,0-1h-5a.48.48,0,0,0-.49.48v10a.48.48,0,0,0,.49.48h5a.48.48,0,0,0,.48-.48A.49.49,0,0,0,304,252h-4.51v-9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.06,377.15h-10a.48.48,0,0,0-.48.49v10a.48.48,0,0,0,.48.48h10a.48.48,0,0,0,.48-.48v-10A.48.48,0,0,0,348.06,377.15Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.06,270.4h-10a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.49h10a.48.48,0,0,0,.48-.49v-10A.48.48,0,0,0,348.06,270.4Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.49,188.92v10a.48.48,0,0,0,.49.48h10a.48.48,0,0,0,.48-.48v-10a.48.48,0,0,0-.48-.48H299a.48.48,0,0,0-.49.48Zm10,.48h-9v9h9v-9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.06,412.85h-10a.47.47,0,0,0-.48.48v10a.4.4,0,0,0,.07.24.45.45,0,0,0,.41.24h1.79v-1h-1.31v-9h9v6.89h1v-7.37A.47.47,0,0,0,348.06,412.85Z",
    transform: "translate(-145.93 -125.34)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.6,306.94v9.5a.47.47,0,0,0,.48.48h10a.47.47,0,0,0,.48-.48v-9.5Zm10,9h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309,224H299a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.49h10a.48.48,0,0,0,.48-.49v-10A.48.48,0,0,0,309,224Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.06,359.63h-10a.48.48,0,0,0-.48.49v10a.48.48,0,0,0,.48.48h10a.48.48,0,0,0,.48-.48v-10A.48.48,0,0,0,348.06,359.63Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.06,252.88h-10a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.49h10a.48.48,0,0,0,.48-.49v-10A.48.48,0,0,0,348.06,252.88Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.49,171.4v10a.49.49,0,0,0,.49.48h10a.49.49,0,0,0,.48-.48v-10a.48.48,0,0,0-.48-.48H299a.48.48,0,0,0-.49.48Zm10,.48h-9v9h9v-9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.06,395.12h-10a.47.47,0,0,0-.48.48v10a.47.47,0,0,0,.48.48h10a.47.47,0,0,0,.48-.48v-10A.47.47,0,0,0,348.06,395.12Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.06,288.36h-10a.48.48,0,0,0-.48.49v6.34h1v-5.86h9v5.86h1v-6.34A.48.48,0,0,0,348.06,288.36Z",
    transform: "translate(-145.93 -125.34)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309,206.4H299a.47.47,0,0,0-.48.48v10a.47.47,0,0,0,.48.48h10a.47.47,0,0,0,.48-.48v-10A.47.47,0,0,0,309,206.4Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.06,341.67h-10a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.49h10a.48.48,0,0,0,.48-.49v-10A.48.48,0,0,0,348.06,341.67Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.06,234.92h-10a.47.47,0,0,0-.48.48v10a.47.47,0,0,0,.48.48h10a.47.47,0,0,0,.48-.48v-10A.47.47,0,0,0,348.06,234.92Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.49,153.44v10a.49.49,0,0,0,.49.48h10a.49.49,0,0,0,.48-.48v-10A.49.49,0,0,0,309,153H299a.49.49,0,0,0-.49.49Zm10,.48h-9v9h9v-9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.9,440.79h-7.34a.49.49,0,0,0,0,1h7.82a.49.49,0,0,0,.49-.48v-10a.49.49,0,0,0-.49-.49h-10a.49.49,0,0,0-.49.49v2.48a.49.49,0,0,0,1,0v-2h9v9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,430.81H320a.49.49,0,0,0-.49.48v10a.49.49,0,0,0,.49.49h10a.49.49,0,0,0,.48-.49v-10A.49.49,0,0,0,330,430.81Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,323.94H320a.49.49,0,0,0-.49.48v10a.49.49,0,0,0,.49.49h10a.49.49,0,0,0,.48-.49v-10A.49.49,0,0,0,330,323.94Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,377.15H320a.49.49,0,0,0-.49.49v10a.49.49,0,0,0,.49.48h10a.49.49,0,0,0,.48-.48v-10A.49.49,0,0,0,330,377.15Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,270.4H320a.49.49,0,0,0-.49.48v10a.49.49,0,0,0,.49.49h10a.49.49,0,0,0,.48-.49v-10A.49.49,0,0,0,330,270.4Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,412.85H320a.48.48,0,0,0-.49.48v10a.48.48,0,0,0,.49.48h10a.48.48,0,0,0,.48-.48v-10A.48.48,0,0,0,330,412.85Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.48,306.94v9.5a.48.48,0,0,0,.49.48h10a.48.48,0,0,0,.48-.48v-9.5Zm10,9h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,359.63H320a.49.49,0,0,0-.49.49v10a.49.49,0,0,0,.49.48h10a.49.49,0,0,0,.48-.48v-10A.49.49,0,0,0,330,359.63Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,252.88H320a.49.49,0,0,0-.49.48v10a.49.49,0,0,0,.49.49h10a.49.49,0,0,0,.48-.49v-10A.49.49,0,0,0,330,252.88Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,395.12H320a.48.48,0,0,0-.49.48v10a.48.48,0,0,0,.49.48h10a.48.48,0,0,0,.48-.48v-10A.48.48,0,0,0,330,395.12Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,288.36H320a.49.49,0,0,0-.49.49v6.34h1v-5.86h9v5.86h1v-6.34A.49.49,0,0,0,330,288.36Z",
    transform: "translate(-145.93 -125.34)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,341.67H320a.49.49,0,0,0-.49.48v10a.49.49,0,0,0,.49.49h10a.49.49,0,0,0,.48-.49v-10A.49.49,0,0,0,330,341.67Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,234.92H320a.48.48,0,0,0-.49.48v10a.48.48,0,0,0,.49.48h10a.48.48,0,0,0,.48-.48v-10A.48.48,0,0,0,330,234.92Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.61,359.63h-10a.49.49,0,0,0-.48.49v10a.49.49,0,0,0,.48.48h10a.49.49,0,0,0,.49-.48v-10A.49.49,0,0,0,305.61,359.63Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.39,359.63h-10a.49.49,0,0,0-.49.49v10a.49.49,0,0,0,.49.48h10a.49.49,0,0,0,.48-.48v-10A.49.49,0,0,0,269.39,359.63Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.61,395.12h-10a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.48h10a.48.48,0,0,0,.49-.48v-10A.48.48,0,0,0,305.61,395.12Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.39,395.12h-10a.48.48,0,0,0-.49.48v10a.48.48,0,0,0,.49.48h10a.48.48,0,0,0,.48-.48v-10A.48.48,0,0,0,269.39,395.12Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.13,325.73v8.19h-9v-5.86h-1v6.34a.49.49,0,0,0,.48.49h10a.49.49,0,0,0,.49-.49V325A10.24,10.24,0,0,1,305.13,325.73Z",
    transform: "translate(-145.93 -125.34)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.39,323.94H261v1h7.86v9h-9V330a6.57,6.57,0,0,1-1,1.13v3.23a.49.49,0,0,0,.49.49h10a.49.49,0,0,0,.48-.49v-10A.49.49,0,0,0,269.39,323.94Z",
    transform: "translate(-145.93 -125.34)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M287,326.86v2.56a8,8,0,0,0,1,.39v-2.36A5.27,5.27,0,0,1,287,326.86Zm-2.11-2.92h-2.28a8.35,8.35,0,0,0,.3,1h2.4A5.57,5.57,0,0,1,284.91,323.94Z",
    transform: "translate(-145.93 -125.34)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.61,412.85h-10a.48.48,0,0,0-.48.48v10a.48.48,0,0,0,.48.48h10a.48.48,0,0,0,.49-.48v-10A.48.48,0,0,0,305.61,412.85Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.39,412.85H259.31a.47.47,0,0,0-.39.47v10a.59.59,0,0,0,0,.13.49.49,0,0,0,.47.35h10a.48.48,0,0,0,.48-.48v-10A.48.48,0,0,0,269.39,412.85Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.61,341.67h-10a.49.49,0,0,0-.48.48v10a.49.49,0,0,0,.48.49h10a.49.49,0,0,0,.49-.49v-10A.49.49,0,0,0,305.61,341.67Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.39,341.67h-10a.49.49,0,0,0-.49.48v10a.49.49,0,0,0,.49.49h10a.49.49,0,0,0,.48-.49v-10A.49.49,0,0,0,269.39,341.67Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.61,377.15h-10a.49.49,0,0,0-.48.49v10a.49.49,0,0,0,.48.48h10a.49.49,0,0,0,.49-.48v-10A.49.49,0,0,0,305.61,377.15Zm-.48,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.39,377.15h-10a.49.49,0,0,0-.49.49v10a.49.49,0,0,0,.49.48h10a.49.49,0,0,0,.48-.48v-10A.49.49,0,0,0,269.39,377.15Zm-.49,10h-9v-9h9Z",
    transform: "translate(-145.93 -125.34)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.92,306.94v3.37h1V307h9v9H261v1h8.35a.48.48,0,0,0,.48-.48v-9.5Z",
    transform: "translate(-145.93 -125.34)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.41,316v1h2.19v-1Zm0-10v1H277v2.2h1V307h6.6v-1Z",
    transform: "translate(-145.93 -125.34)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.1,200.21v13.22a1,1,0,0,0,1.93,0v-14.6a1,1,0,0,0-1.29-.91l-8.31,3a1,1,0,0,0-.63.91v14.83a1,1,0,0,0,1.93,0V202.52l6.37-2.31Z",
    transform: "translate(-145.93 -125.34)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.93,270.17v21.44a1,1,0,0,1-1,1,.86.86,0,0,1-.41-.1,1,1,0,0,1-.56-.87V271.3l-12.57,2.08V285.8h-1.93V272.56a1,1,0,0,1,.76-.95h.05l8.78-1.45,1.93-.32,3.79-.62a1,1,0,0,1,1.13,1Z",
    transform: "translate(-145.93 -125.34)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.14,276.13l-14.5,2.81a1,1,0,1,1-.37-1.9l14.5-2.81a1,1,0,1,1,.37,1.9Z",
    transform: "translate(-145.93 -125.34)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 135.61,
    y: 324.19,
    width: 1.94,
    height: 2.19
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 135.61,
    y: 332.79,
    width: 1.94,
    height: 2.19
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M281.54,475.33h1.94V477a.9.9,0,0,1-.2.57,1,1,0,0,1-1.54,0,.9.9,0,0,1-.2-.57Z",
    transform: "translate(-145.93 -125.34)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.66,448.1V477a1,1,0,1,1-1.94,0V448.1a1,1,0,0,1,1.94,0Z",
    transform: "translate(-145.93 -125.34)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.11,452V477a1,1,0,0,0,1.94,0v-25.9a1,1,0,0,0-1-1H185.79a1,1,0,0,0-1,1V477a1,1,0,0,0,1.94,0V452Z",
    transform: "translate(-145.93 -125.34)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.62,458.6V477a1,1,0,0,0,1.94,0V457.64a1,1,0,0,0-1-1H202.28a1,1,0,0,0-1,1V477a1,1,0,0,0,1.94,0V458.6Z",
    transform: "translate(-145.93 -125.34)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.4,457.64V477a1,1,0,1,1-1.93,0V457.64a1,1,0,1,1,1.93,0Z",
    transform: "translate(-145.93 -125.34)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.75,290.82v9.77a1,1,0,1,0,1.93,0V290.06a1,1,0,0,0-.74-.94l-14.79-3.49a1,1,0,0,0-1.19.95v11.85a1,1,0,0,0,1.94,0V287.8l12.85,3Z",
    transform: "translate(-145.93 -125.34)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.36,288.32V274.14a1,1,0,1,1,1.93,0v14.18a1,1,0,0,1-1.93,0Z",
    transform: "translate(-145.93 -125.34)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.89,447.45v29.22a.49.49,0,0,1-1,0V447.45a.49.49,0,0,1,1,0Z",
    transform: "translate(-145.93 -125.34)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.05,449.5a4.17,4.17,0,0,0-.1.94,4.58,4.58,0,0,0,4.58,4.58,4.38,4.38,0,0,0,1.66-.32.5.5,0,0,1,.63.28.47.47,0,0,1-.27.62,5.45,5.45,0,0,1-2,.38,5.55,5.55,0,0,1-5.55-5.54,5.38,5.38,0,0,1,.12-1.14.49.49,0,0,1,.57-.38.5.5,0,0,1,.38.58Z",
    transform: "translate(-145.93 -125.34)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.66,451.38a4.74,4.74,0,0,0,1.3-.3,4.59,4.59,0,0,0,2.87-3.69.49.49,0,0,1,.54-.42.48.48,0,0,1,.42.54,5.54,5.54,0,0,1-3.48,4.47,5.44,5.44,0,0,1-1.58.36.49.49,0,0,1-.52-.44.48.48,0,0,1,.45-.52Z",
    transform: "translate(-145.93 -125.34)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.13,447.73V477a.49.49,0,0,1-1,0V447.73a.49.49,0,0,1,1,0Z",
    transform: "translate(-145.93 -125.34)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.9,451.66a4.74,4.74,0,0,0,1.3-.3,4.58,4.58,0,0,0,2.87-3.69.48.48,0,0,1,1,.12,5.56,5.56,0,0,1-3.48,4.47,5.44,5.44,0,0,1-1.58.36.48.48,0,1,1-.07-1Z",
    transform: "translate(-145.93 -125.34)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.25,414.47a6,6,0,0,1,5.92-5h11a6,6,0,0,1,6,6v17.3a.49.49,0,0,1-1,0v-17.3a5,5,0,0,0-5-5h-11a5,5,0,0,0-5,4.22.49.49,0,0,1-.56.4.49.49,0,0,1-.4-.56Z",
    transform: "translate(-145.93 -125.34)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M173.17,449.4v20.35a.49.49,0,0,1-1,0V449.4a.49.49,0,1,1,1,0Z",
    transform: "translate(-145.93 -125.34)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169.45,469.75V477a.48.48,0,0,0,.48.48h5.5a.48.48,0,0,0,.49-.48v-7.2a.48.48,0,0,0-.49-.48h-5.5a.48.48,0,0,0-.48.48Zm5.5.48h-4.53v6.24H175v-6.24Z",
    transform: "translate(-145.93 -125.34)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237,414.47a6,6,0,0,1,5.91-5h11a6,6,0,0,1,6,6v18.35a.49.49,0,0,1-1,0V415.43a5,5,0,0,0-5-5h-11a5,5,0,0,0-5,4.22.48.48,0,0,1-.55.4.47.47,0,0,1-.4-.56Z",
    transform: "translate(-145.93 -125.34)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.9,449.46v12.26a4.91,4.91,0,0,0-1,1.16V449.46a.48.48,0,1,1,1,0Z",
    transform: "translate(-145.93 -125.34)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238,414.24a3.31,3.31,0,0,0-.55-.05,3,3,0,0,0-.43,0,3.4,3.4,0,0,0-2.94,3.33,3.3,3.3,0,0,0,.93,2.31,3.36,3.36,0,1,0,3-5.62Zm-.55,5.71a2.4,2.4,0,1,1,2.39-2.4A2.39,2.39,0,0,1,237.47,420Z",
    transform: "translate(-145.93 -125.34)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M261.69,475.33v1.13h-4.54v-6.23h1v-1h-1.47a.48.48,0,0,0-.48.49V477a.48.48,0,0,0,.48.48h5.5a.48.48,0,0,0,.48-.48v-1.62Z",
    transform: "translate(-145.93 -125.34)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M229.23,295.19H284.6V293H229.23a8.08,8.08,0,0,0-8.08,8.06,4,4,0,0,0,0,.49,8,8,0,0,0,8.06,7.59H284.6v-2.2H229.23a5.87,5.87,0,0,1-5-2.87,5.56,5.56,0,0,1-.75-2.1h0a4.43,4.43,0,0,1-.08-.9A5.88,5.88,0,0,1,229.23,295.19ZM417.43,293H308.84a.36.36,0,0,1,0,.09,11.59,11.59,0,0,1,.86,2.1H417.43a5.88,5.88,0,1,1,0,11.75H310.31v2.2H417.43a8.07,8.07,0,1,0,0-16.14Z",
    transform: "translate(-145.93 -125.34)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M274.69,458.13v2.19h6.85v-2.19Zm0,0v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm0,0v-5.1h-1V476h33.18v-.65Zm0,0v-5.1h-1V476h33.18v-.65Zm49.09-17.2H263.5a7.34,7.34,0,0,0-3.6.93,5.42,5.42,0,0,0-1,.62,7.49,7.49,0,0,0-3,6v11.84h56.93V463.79A5.65,5.65,0,0,0,307.23,458.13Zm-49.09,7.55a5.23,5.23,0,0,1,.8-2.8,4.91,4.91,0,0,1,1-1.16,5.34,5.34,0,0,1,3.6-1.4h43.73a3.47,3.47,0,0,1,3.46,3.47v11.54H258.14Zm0,9.65v-5.1h-1V476h33.18v-.65Zm0,0v-5.1h-1V476h33.18v-.65Zm0,0v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm-16.55,17.2v-5.1h-1V476h4.54v-.65Zm16.55-17.2v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h6.85v-2.19Z",
    transform: "translate(-145.93 -125.34)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M274.69,449.53v2.19h15.64v-2.19Zm0,8.6v2.19h6.85v-2.19Zm0-8.6v2.19h15.64v-2.19Zm0,8.6v2.19h6.85v-2.19Zm0-8.6v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,8.6v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm25.11-8.6H270.94a6.38,6.38,0,0,0-6.39,6.37v4.42h41.17v-4.87A5.92,5.92,0,0,0,299.8,449.53Zm-33.06,8.6V455.9a4.2,4.2,0,0,1,4.2-4.18H299.8a3.73,3.73,0,0,1,3.73,3.73v2.68Zm7.95,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0-8.6v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,0v2.19h15.64v-2.19Zm0,8.6v2.19h6.85v-2.19Zm0-8.6v2.19h15.64v-2.19Zm0,8.6v2.19h6.85v-2.19Zm0-8.6v2.19h15.64v-2.19Z",
    transform: "translate(-145.93 -125.34)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M276,275.38l-1.39.81V293h2.19V275.38Zm-1.39-4.93V451.72h19.66V328.06h-2.2V449.53H276.78V272.64h15.27V285.8h2.2V270.45Z",
    transform: "translate(-145.93 -125.34)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.41,295.19v11.75h2.19V295.19Zm0,0v11.75h2.19V295.19Zm0,0v11.75h2.19V295.19Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31Zm-25.39,6.52v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31Zm-25.39,6.52v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31Zm-25.39,6.52v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31Zm-25.39,6.52v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31Zm-25.39,6.52v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31Zm-25.39,6.52v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31Zm-25.39,6.52v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31Zm-25.39,6.52v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31Zm-25.39,6.52v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31Zm-25.39,6.52v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31Zm-25.39,6.52v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-4.22-3.87a1.85,1.85,0,0,1,.19.27v-.31ZM282.41,307v9h2.19v-9Zm0-9.11v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM282.41,307v9h2.19v-9Zm0-9.11v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM282.41,307v9h2.19v-9Zm0-9.11v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM282.41,307v9h2.19v-9Zm0-9.11v9.1h2.19v-9.49Zm0-2.65v.68l1.07-.19,1.12-.2v-.29Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM282.41,307v9h2.19v-9Zm0-11.76v11.75h2.19V295.19Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM282.41,307v9h2.19v-9Zm0-11.76v11.75h2.19V295.19Zm29.61,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM282.41,307v9h2.19v-9Zm1.07-11.76v.49l1.12-.2v-.29Zm28.54,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM282.41,307v9h2.19v-9Zm1.07-11.76v.49l1.12-.2v-.29Zm28.54,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,11.58v.49l1.12-.2v-.29Zm28.54,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,11.58v.49l1.12-.2v-.29Zm28.54,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,11.58v.49l1.12-.2v-.29Zm28.54,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,11.58v.49l1.12-.2v-.29Zm28.54,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,11.58v.49l1.12-.2v-.29Zm28.54,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,11.58v.49l1.12-.2v-.29Zm28.54,0a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-14.95-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,11.58v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,11.58v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,11.58v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,12.07,1.12-.2v-.29h-1.12Zm28.54-.49a14.91,14.91,0,0,0-.76-2.19,2.2,2.2,0,0,0-.15-.31,12.85,12.85,0,0,0-.95-1.8c-.07-.12-.15-.24-.23-.35a14.31,14.31,0,0,0-1.94-2.38,15.37,15.37,0,0,0-10.92-4.55h-6.72a8,8,0,0,0-7.94,7.94v30.5a7.94,7.94,0,0,0,.52,2.86,8.23,8.23,0,0,0,4.09,4.51,8,8,0,0,0,1,.39,7.91,7.91,0,0,0,2.64.44h7.29a14.5,14.5,0,0,0,7.22-1.92c.33-.19.66-.39,1-.61a14.56,14.56,0,0,0,6.4-12.06V299A15.33,15.33,0,0,0,312,295.19Zm-1.71,20.47a12.36,12.36,0,0,1-4.21,9.3,10.24,10.24,0,0,1-1,.77,12.28,12.28,0,0,1-7.22,2.33h-7.29a6,6,0,0,1-2.64-.61,5.27,5.27,0,0,1-1-.59,5.87,5.87,0,0,1-1.69-1.95,5.57,5.57,0,0,1-.42-1,5.9,5.9,0,0,1-.31-1.89v-30.5a5.76,5.76,0,0,1,5.75-5.75h6.72a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27,10.23,10.23,0,0,1,.56.89c.1.17.2.34.29.52a.36.36,0,0,1,0,.09,11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85Zm-26.83-20.47v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,11.58v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61Zm-13.59,11.58v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-28.54,0v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-28.54,0v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-28.54,0v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-28.54,0v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-28.54,0v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-28.54,0v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-28.54,0v.49l1.12-.2v-.29Zm13.59-11.58h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-28.54,0v.49l1.12-.2v-.29ZM282.41,307v9h2.19v-9Zm14.66-23.34h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v11.75h2.19V295.19Zm0,11.76v9h2.19v-9Zm14.66-23.34h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v11.75h2.19V295.19Zm0,11.76v9h2.19v-9Zm14.66-23.34h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm0,9.11v9h2.19v-9Zm14.66-23.34h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm0,9.11v9h2.19v-9Zm14.66-23.34h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm0,9.11v9h2.19v-9Zm14.66-23.34h-2.82v2.19h2.82a13.2,13.2,0,0,1,10.73,5.52,1.85,1.85,0,0,1,.19.27v-3.43A15.37,15.37,0,0,0,297.07,283.61ZM312,295.19a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm0,9.11v9h2.19v-9Zm25.39-15.63a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm0,9.11v9h2.19v-9Zm25.39-15.63a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm25.39-6.52a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm25.39-6.52a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm25.39-6.52a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm25.39-6.52a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm25.39-6.52a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm25.39-6.52a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm25.39-6.52a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm25.39-6.52a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm25.39-6.52a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm25.39-6.52a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v.68l1.07-.19,1.12-.2v-.29Zm0,2.65v9.1h2.19v-9.49Zm25.39-6.52a1.85,1.85,0,0,1,.19.27v-.31Zm4.22,3.87a14.91,14.91,0,0,0-.76-2.19h-1.87l-.51.09a11.59,11.59,0,0,1,.86,2.1,13.28,13.28,0,0,1,.57,3.85v7.9h2.19V299A15.33,15.33,0,0,0,312,295.19Zm-29.61,0v11.75h2.19V295.19Zm0,0v11.75h2.19V295.19Z",
    transform: "translate(-145.93 -125.34)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M386.35,333v31.33h28.59V333Zm26.39,29.13h-24.2V335.2h24.2Z",
    transform: "translate(-145.93 -125.34)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242.45,333v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h7.11V333Zm0,0v2.19h7.11V333Zm0,0v2.19h7.11V333Zm17.44-23.87v1.17H261V316h2.19v-6.82ZM261,324.91v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37ZM242.45,333v2.19h7.11V333Zm18.59-8.1v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37Zm-1.15-15.77v1.17H261V316h2.19v-6.82ZM244.39,333v2.19h5.17V333Zm-12.82-8.1h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm29.47,0v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37Zm-1.15-15.77v1.17H261V316h2.19v-6.82ZM244.39,333v2.19h5.17V333Zm-12.82-8.1h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm29.47,0v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37Zm-1.15-15.77v1.17H261V316h2.19v-6.82ZM244.39,333v2.19h5.17V333Zm-12.82-8.1h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm29.47,0v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37Zm-1.15-15.77v1.17H261V316h2.19v-6.82ZM244.39,333v2.19h5.17V333Zm-12.82-8.1h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm29.47,0v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37Zm-1.15-15.77v1.17H261V316h2.19v-6.82ZM244.39,333v2.19h5.17V333Zm-12.82-8.1h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm29.47,0v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37Zm-1.15-15.77v1.17H261V316h2.19v-6.82ZM244.39,333v2.19h5.17V333Zm-12.82-8.1h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm19.93-15.77v1.17H261v16a6.66,6.66,0,0,1-1.15,3.76,6.57,6.57,0,0,1-1,1.13,6.66,6.66,0,0,1-4.6,1.84h-9.93v2.19h9.93a8.88,8.88,0,0,0,4.6-1.28,8.48,8.48,0,0,0,1-.69,8.86,8.86,0,0,0,3.34-7V309.14Zm-19.93,15.77h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm19.93-15.77v1.17H261v16a6.66,6.66,0,0,1-1.15,3.76,6.57,6.57,0,0,1-1,1.13,6.66,6.66,0,0,1-4.6,1.84h-9.93v2.19h9.93a8.88,8.88,0,0,0,4.6-1.28,8.48,8.48,0,0,0,1-.69,8.86,8.86,0,0,0,3.34-7V309.14Zm-22.12,15.77a10.67,10.67,0,0,0,4.68,8.46v-2.84a8.4,8.4,0,0,1-2.49-5.62Zm0-16.79v16.41c0,.13,0,.25,0,.38a10.67,10.67,0,0,0,4.68,8.46,10.36,10.36,0,0,0,1,.58,10.54,10.54,0,0,0,5,1.25h14.28a8.88,8.88,0,0,0,4.6-1.28,8.48,8.48,0,0,0,1-.69,8.86,8.86,0,0,0,3.34-7V308.12ZM261,326.28a6.66,6.66,0,0,1-1.15,3.76,6.57,6.57,0,0,1-1,1.13,6.66,6.66,0,0,1-4.6,1.84H240a8.38,8.38,0,0,1-5-1.65,8.5,8.5,0,0,1-1-.83,8.4,8.4,0,0,1-2.49-5.62c0-.13,0-.25,0-.38V310.31H261Zm-29.47-1.37h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm19.93-15.77v1.17H261v16a6.66,6.66,0,0,1-1.15,3.76,6.57,6.57,0,0,1-1,1.13,6.66,6.66,0,0,1-4.6,1.84h-9.93v2.19h9.93a8.88,8.88,0,0,0,4.6-1.28,8.48,8.48,0,0,0,1-.69,8.86,8.86,0,0,0,3.34-7V309.14Zm-19.93,15.77h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm19.93-15.77v1.17H261v16a6.66,6.66,0,0,1-1.15,3.76,6.57,6.57,0,0,1-1,1.13,6.66,6.66,0,0,1-4.6,1.84h-9.93v2.19h9.93a8.88,8.88,0,0,0,4.6-1.28,8.48,8.48,0,0,0,1-.69,8.86,8.86,0,0,0,3.34-7V309.14Zm-19.93,15.77h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm12.82,8.1v2.19h5.17V333Zm15.5-23.87v1.17H261V316h2.19v-6.82ZM261,324.91v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37Zm-29.47,0h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm12.82,8.1v2.19h5.17V333Zm15.5-23.87v1.17H261V316h2.19v-6.82ZM261,324.91v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37Zm-29.47,0h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm12.82,8.1v2.19h5.17V333Zm15.5-23.87v1.17H261V316h2.19v-6.82ZM261,324.91v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37Zm-29.47,0h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm12.82,8.1v2.19h5.17V333Zm15.5-23.87v1.17H261V316h2.19v-6.82ZM261,324.91v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37Zm-29.47,0h-2.19a10.67,10.67,0,0,0,4.68,8.46v-2.84A8.4,8.4,0,0,1,231.57,324.91Zm12.82,8.1v2.19h5.17V333Zm15.5-23.87v1.17H261V316h2.19v-6.82ZM261,324.91v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37ZM244.39,333v2.19h5.17V333Zm15.5-23.87v1.17H261V316h2.19v-6.82ZM261,324.91v1.37a6.66,6.66,0,0,1-1.15,3.76v3.19a8.86,8.86,0,0,0,3.34-7v-1.37ZM242.45,333v2.19h7.11V333Zm17.44-23.87v1.17H261V316h2.19v-6.82ZM242.45,333v2.19h7.11V333Zm0,0v2.19h7.11V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Zm0,0v2.19h9.05V333Z",
    transform: "translate(-145.93 -125.34)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "281.78 246.51 281.78 351.09 279.59 351.09 279.59 248.7 270.31 248.7 270.31 274.77 238.92 274.77 238.92 248.7 227.82 248.7 227.82 277.64 210.88 277.64 210.88 295.36 193.94 295.36 193.94 351.09 191.74 351.09 191.74 293.17 208.69 293.17 208.69 275.44 225.63 275.44 225.63 246.51 241.12 246.51 241.12 272.58 268.12 272.58 268.12 246.51 281.78 246.51"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "213.49 346.66 211.29 346.66 211.29 331.49 227.25 331.49 227.25 333.68 213.49 333.68 213.49 346.66"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "237.86 346.66 235.66 346.66 235.66 331.49 251.62 331.49 251.62 333.68 237.86 333.68 237.86 346.66"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "260.04 346.66 257.84 346.66 257.84 331.49 273.8 331.49 273.8 333.68 260.04 333.68 260.04 346.66"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "213.49 324.19 211.29 324.19 211.29 309.01 227.25 309.01 227.25 311.21 213.49 311.21 213.49 324.19"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "237.86 324.19 235.66 324.19 235.66 309.01 251.62 309.01 251.62 311.21 237.86 311.21 237.86 324.19"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "260.04 324.19 257.84 324.19 257.84 309.01 273.8 309.01 273.8 311.21 260.04 311.21 260.04 324.19"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "237.86 300.78 235.66 300.78 235.66 285.61 251.62 285.61 251.62 287.8 237.86 287.8 237.86 300.78"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "260.04 300.78 257.84 300.78 257.84 285.61 273.8 285.61 273.8 287.8 260.04 287.8 260.04 300.78"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "129.46 147.85 130.85 147.85 130.85 150.04 130.05 150.04 128.66 150.85 99.92 167.66 96.43 169.7 95.32 167.8 95.56 167.66 128.66 148.32 129.46 147.85"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "253.65 167.67 253.24 169.83 241.59 167.66 148.31 150.26 147.12 150.04 146.12 150.04 146.12 147.86 147.43 147.86 148.31 148.02 253.59 167.66 253.65 167.67"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "244.93 209.44 243.19 208.09 252.35 196.27 252.35 181.59 254.54 181.59 254.54 197.02 244.93 209.44"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 404.04,
    y: 319.68,
    width: 2.19,
    height: 16.73,
    transform: "translate(-260.42 244.34) rotate(-43.58)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M445.44,476.63c0,.71-.37,1.28-.82,1.28H151.53c-.44,0-.8-.57-.8-1.28s.36-1.3.8-1.3H444.62C445.07,475.33,445.44,475.91,445.44,476.63Z",
    transform: "translate(-145.93 -125.34)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 130.82,
    y: 147.3,
    width: 3.77,
    height: 176.89
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 242.61,
    y: 209.86,
    width: 24.2,
    height: 26.94
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 42.46,
    y: 199.15,
    width: 9.74,
    height: 9.39
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 42.46,
    y: 217.23,
    width: 9.74,
    height: 9.39
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 42.46,
    y: 234.98,
    width: 9.74,
    height: 9.39
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 42.46,
    y: 252.59,
    width: 9.74,
    height: 9.39
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 42.46,
    y: 270.44,
    width: 9.74,
    height: 9.39
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.27,
    y: 270.44,
    width: 9.74,
    height: 9.39
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.27,
    y: 252.59,
    width: 9.74,
    height: 9.39
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.27,
    y: 235.07,
    width: 9.74,
    height: 9.39
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.27,
    y: 217.11,
    width: 9.74,
    height: 9.39
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.27,
    y: 199.57,
    width: 9.74,
    height: 9.39
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.27,
    y: 145.84,
    width: 9.74,
    height: 9.39
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.27,
    y: 128.32,
    width: 9.74,
    height: 9.39
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.27,
    y: 110.36,
    width: 9.74,
    height: 9.39
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 153.17,
    y: 99.45,
    width: 9.74,
    height: 9.39
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 153.17,
    y: 81.66,
    width: 9.74,
    height: 9.39
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 153.17,
    y: 63.87,
    width: 9.74,
    height: 9.39
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 153.17,
    y: 46.08,
    width: 9.74,
    height: 9.39
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 153.17,
    y: 28.29,
    width: 9.74,
    height: 9.39
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 153.19,
    y: 117.41,
    width: 4.87,
    height: 9.39
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 42.46,
    y: 288.29,
    width: 9.74,
    height: 9.39
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 42.46,
    y: 306.25,
    width: 9.74,
    height: 9.39
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M298.32,317.08a3,3,0,0,1-1.48-.7c-1.53-1.18-3-2.37-4.56-3.56a4.18,4.18,0,0,1-.52-.51,1.4,1.4,0,0,1-.22-1.55,5.29,5.29,0,0,1,1.52-2,1.15,1.15,0,0,1,1.56,0c.74.48,1.41,1.07,2.11,1.6.28.21.57.42.83.65s.34.17.51-.06c1-1.4,2-2.77,3.05-4.16.82-1.11,1.61-2.24,2.42-3.35a5.55,5.55,0,0,1,1.18-1.19,1.9,1.9,0,0,1,2.08-.17,2.84,2.84,0,0,1,1.55,1.6,2.09,2.09,0,0,1,0,.66,4.54,4.54,0,0,1-1.17,2.24c-1.17,1.57-2.33,3.16-3.5,4.74l-3.67,5a1.6,1.6,0,0,1-1.3.81Z",
    transform: "translate(-145.93 -125.34)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.75,296.43a14.44,14.44,0,0,1,3.46,2.39c.91.69,1.81,1.39,2.67,2.13a1.49,1.49,0,0,1,.34,2.16,5.54,5.54,0,0,1-1.26,1.55,1.16,1.16,0,0,1-1.69.09c-1-.7-1.89-1.44-2.83-2.16-.38-.3-.37-.3-.67.11-1.78,2.43-3.6,4.82-5.33,7.28a5.27,5.27,0,0,1-1.28,1.3,2,2,0,0,1-2.14.1,2.72,2.72,0,0,1-1.4-1.41l0-.05,0-.15a.31.31,0,0,1,0-.08,3.16,3.16,0,0,1,0-.43,2.39,2.39,0,0,1,.54-1.38c.62-.94,1.32-1.82,2-2.72l3.82-5.15,2.09-2.82a1.77,1.77,0,0,1,1.14-.76Z",
    transform: "translate(-145.93 -125.34)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.27,307.71c0,.76,0,.76-.76.76s-.7,0-.7-.71,0-.81.79-.81S297.27,307,297.27,307.71Z",
    transform: "translate(-145.93 -125.34)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.61,307.69c0-.74,0-.74.71-.74s.74,0,.74.79,0,.73-.69.73S297.61,308.47,297.61,307.69Z",
    transform: "translate(-145.93 -125.34)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M298.29,306.64c-.74,0-.74,0-.74-.76s0-.75.72-.75.77,0,.77.8S299,306.64,298.29,306.64Z",
    transform: "translate(-145.93 -125.34)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M295.8,305.89c0-.75,0-.75.73-.75s.73,0,.73.74,0,.76-.72.76S295.8,306.64,295.8,305.89Z",
    transform: "translate(-145.93 -125.34)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249.56,333h1.94v88.26a.72.72,0,0,1-.07.33.94.94,0,0,1-.9.63,1,1,0,0,1-1-1Z",
    transform: "translate(-145.93 -125.34)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.28,455.31,240.83,453l.08-3.78-2.44.32-2.23-2.11-2.14-2.63-1.16-2.49a14.89,14.89,0,0,1-.36-2.26c.06-.36.95-2.44.95-2.44s.69-1.61.53-1.9.53-2.36.48-2.78a15.31,15.31,0,0,1,1.28-2.91l2.23-.6,1.81-2.5,1.64-1.84,3.1-1s5,.81,5.45,1.58,1.35,10.34,1.45,11.53-4.34,7.07-4.34,7.07l.93,2.68.71,3.22-.71,4-.45,1.13s-2.34.23-2.64.35a9.54,9.54,0,0,1-2-.14Z",
    transform: "translate(-145.93 -125.34)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.94,432.4l0,0a7.39,7.39,0,0,0-2.7-1.74,7.22,7.22,0,0,0,.29-2,7.36,7.36,0,0,0-5.08-7,6.81,6.81,0,0,0-1.87-.35,3.1,3.1,0,0,0-.43,0,7.34,7.34,0,0,0-4.74,1.73,7.08,7.08,0,0,0-1,1.07,5,5,0,0,0-.77.15,5.73,5.73,0,0,0-4.1,4.3,7.23,7.23,0,0,0-3.55,2.51,7,7,0,0,0-.86,1.41,7.29,7.29,0,0,0-.68,3.1,7.61,7.61,0,0,0,.15,1.52,5.69,5.69,0,0,0-1.36,3.7v.07a4.51,4.51,0,0,0,.11,1,5.64,5.64,0,0,0,2,3.39,5.71,5.71,0,0,0,5.66,5h.31a5.6,5.6,0,0,0,1-.14,5.72,5.72,0,0,0,3.45-2.41l.36.15a7.11,7.11,0,0,0,.93.27,6.47,6.47,0,0,0,1.17.17l.49,0,.48,0v-.46a.49.49,0,0,0-.48-.49,6.51,6.51,0,0,1-2.92-.69.48.48,0,0,0-.64.19,4.74,4.74,0,0,1-8.87-1.89.46.46,0,0,0-.19-.34,4.76,4.76,0,0,1-.62-7,.45.45,0,0,0,.12-.44,6.56,6.56,0,0,1-.19-1.54,6.44,6.44,0,0,1,4.68-6.18.47.47,0,0,0,.35-.38,4.73,4.73,0,0,1,4.27-4,.52.52,0,0,0,.35-.2,6.41,6.41,0,0,1,11.55,3.83,6.27,6.27,0,0,1-.38,2.17.53.53,0,0,0,0,.39.52.52,0,0,0,.3.24,6.38,6.38,0,0,1,3.47,2.52l0,0s0,0,0,0l.07.11v0l0,0h0l.11.06h0l.05,0h.11a.33.33,0,0,0,.17,0h0a.36.36,0,0,0,.14-.1.23.23,0,0,0,.08-.12h0s0,0,0,0a0,0,0,0,0,0,0,.35.35,0,0,0,0-.17v-.18A7.26,7.26,0,0,0,258.94,432.4Z",
    transform: "translate(-145.93 -125.34)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241.29,449.78a4.17,4.17,0,0,0-.1.94,4.58,4.58,0,0,0,4.57,4.58,4.63,4.63,0,0,0,1.67-.31.48.48,0,1,1,.35.9,5.54,5.54,0,0,1-7.56-5.17,5.38,5.38,0,0,1,.12-1.14.47.47,0,0,1,.57-.37.49.49,0,0,1,.38.57Z",
    transform: "translate(-145.93 -125.34)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.76,452.2a4.83,4.83,0,0,0,1.15.14,4.56,4.56,0,0,0,4.54-4,.48.48,0,0,1,.54-.42.49.49,0,0,1,.42.54,5.58,5.58,0,0,1-3.48,4.47,5.66,5.66,0,0,1-2,.38,5.35,5.35,0,0,1-1.39-.18.48.48,0,1,1,.24-.93Z",
    transform: "translate(-145.93 -125.34)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.86,428l1.69-3.31,2.45-.61,1.33-1.1c.53-.45,3.38-2,3.38-2l3.45.87a17.63,17.63,0,0,1,2.49,1.37c.12.23,1.49,2.49,1.49,2.49l.16,2.55.25,1.91s1.55,1.43,1.79,1.54,2.67,2.15,2.67,2.15l.3,2.36v2.38l.15.89.72,2.2,1,1.43.24,2.14-.75,2.3s-2.32,1.53-2.64,1.41a16.74,16.74,0,0,0-2.67.27c-.18,0-2.5-.66-2.5-.66l-.59,1.23-1.19,1.33-1.71.54s-4.26-.76-5.43-1.87-5.4-6.34-5.4-6.34-2.19-6.59-2.19-7.72S152.86,428,152.86,428Z",
    transform: "translate(-145.93 -125.34)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.9,420.2l1.37-.25a12,12,0,0,0,1.3-1.63,6,6,0,0,0,.3-1.95,21.16,21.16,0,0,0-1.63-1.81l-2-.09-1,1.2v1.89Z",
    transform: "translate(-145.93 -125.34)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170,430.36a7.41,7.41,0,0,1,4.48,9.2,5.71,5.71,0,1,1-8.6,6.87,7.38,7.38,0,0,1-7.4.89A5.7,5.7,0,0,1,148,444.87a5.71,5.71,0,0,1-.75-8.13,7.61,7.61,0,0,1-.15-1.52,7.39,7.39,0,0,1,5.09-7,5.73,5.73,0,0,1,4.87-4.45,7.38,7.38,0,0,1,13.17,4.58,7.22,7.22,0,0,1-.29,2Zm-.74.77a6.42,6.42,0,0,1,4.61,6.15,6.31,6.31,0,0,1-.43,2.3.48.48,0,0,0,.2.58,4.74,4.74,0,1,1-7.07,5.32.48.48,0,0,0-.79-.22A6.41,6.41,0,0,1,161.4,447a6.5,6.5,0,0,1-2.91-.7.48.48,0,0,0-.64.19,4.74,4.74,0,0,1-8.87-1.89.47.47,0,0,0-.19-.34,4.74,4.74,0,0,1-.62-7,.47.47,0,0,0,.12-.45,6.49,6.49,0,0,1-.19-1.54,6.42,6.42,0,0,1,4.68-6.17.51.51,0,0,0,.35-.39,4.73,4.73,0,0,1,4.27-4,.55.55,0,0,0,.35-.2,6.41,6.41,0,0,1,11.55,3.83,6.27,6.27,0,0,1-.38,2.17.48.48,0,0,0,0,.39.52.52,0,0,0,.3.24Z",
    transform: "translate(-145.93 -125.34)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.53,451.91a4.24,4.24,0,0,0,1.14.15,4.56,4.56,0,0,0,4.54-4,.47.47,0,0,1,.54-.42.49.49,0,0,1,.42.54,5.56,5.56,0,0,1-3.48,4.47,5.66,5.66,0,0,1-2,.38,5.35,5.35,0,0,1-1.39-.18.49.49,0,0,1,.25-.94Z",
    transform: "translate(-145.93 -125.34)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.73,414.2a3.36,3.36,0,1,0,3.36,3.36,3.35,3.35,0,0,0-3.36-3.36Zm0,1a2.4,2.4,0,1,1-2.39,2.4,2.4,2.4,0,0,1,2.39-2.4Z",
    transform: "translate(-145.93 -125.34)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSazandegan);
export default __webpack_public_path__ + "static/media/sazandegan.d62c69a4e9f91d30f2e8970bb4dd7abc.svg";
export { ForwardRef as ReactComponent };